import axios from 'axios';
import { getDomainOrigin, getAxiosConfig } from 'utils/serverConfig';

interface PaymentMethodResponse {
    data: {
        orderEkey: string;
        net_payable: number;
        premium: number;
        available_method: string[];
        has_sufficient_balance: boolean;
    };
    status: boolean;
    statusCode: number;
}

export const getPaymentMethod = async (
    partnerId: string,
    orderEkey: string,
    groupName: string
): Promise<PaymentMethodResponse> => {
    try {
        const { status, data } = await axios(
            `${getDomainOrigin()}/api/mpos/partner/${partnerId}/wallet/payment-summary?order_ekey=${orderEkey}&user_group=${groupName}`,
            {
                method: 'GET',
                ...getAxiosConfig(),
            }
        );

        if (status === 200 && data) {
            return {
                data: {
                    orderEkey: data.order_ekey,
                    net_payable: data.net_payable,
                    premium: data.premium,
                    available_method: data.available_method || [
                        'WALLET',
                        'PAYMENT_GATEWAY',
                    ],
                    has_sufficient_balance: data.has_sufficient_balance,
                },
                status: true,
                statusCode: 200,
            };
        }
    } catch (e: any) {
        if (e?.response?.status === 401) {
            return {
                data: {
                    orderEkey: '',
                    net_payable: 0,
                    premium: 0,
                    available_method: [],
                    has_sufficient_balance: false,
                },
                status: false,
                statusCode: 401,
            };
        }
        return {
            data: {
                orderEkey: '',
                net_payable: 0,
                premium: 0,
                available_method: [],
                has_sufficient_balance: false,
            },
            status: false,
            statusCode: 500,
        };
    }
    return {
        data: {
            orderEkey: '',
            net_payable: 0,
            premium: 0,
            available_method: [],
            has_sufficient_balance: false,
        },
        status: false,
        statusCode: 500,
    };
};

export const completePayment = async (partnerId: string, orderEkey: string) => {
    try {
        const { status, data } = await axios(
            `${getDomainOrigin()}/api/mpos/partner/${partnerId}/wallet/create-payment`,
            {
                method: 'POST',
                data: {
                    order_ekey: orderEkey,
                },
                ...getAxiosConfig(),
            }
        );

        if (status === 200) {
            return {
                status: true,
                statusCode: 200,
                data,
            };
        }
        return {
            status: false,
            statusCode: 500,
            data: null,
        };
    } catch (e: any) {
        if (e?.response?.status === 401) {
            return {
                status: false,
                statusCode: 401,
                data: null,
            };
        }
        return {
            status: false,
            statusCode: 500,
            data: null,
        };
    }
};
